import React, { Component } from 'react';

import format from '../utility/format';

import './BarChart.css';

// original blue, orange, mint
// const PALETTE = ['#2D9CDB', '#F2994A', '#489C97'];
// material light green (darkest)
// const PALETTE = ['#003d00', '#33691e', '#629749'];
// material green (2nd darkest) 
// const PALETTE = ['#005005' '#2e7d32' '#60ad5e'];
const PALETTE = ['#004204', '#318236', '#60ad5e'];

function color(i) {
  return PALETTE[i % PALETTE.length];
}

export default class CollapsingBarChart extends Component {

  state = {
    width: 0,
  }

  constructor(props) {
    super(props);

    this.state = {
      width: 0
    }
    this.containerRef = React.createRef();
    this._updateDimensions = this._updateDimensions.bind(this);
  }

  componentDidMount() {
    this._updateDimensions();
    window.addEventListener('resize', this._updateDimensions);
  }

  UNSAFE_componentWillUnmount() {
    window.removeEventListener('resize', this._updateDimensions);
  }

  _updateDimensions() {
    var currentRef = this.containerRef.current;
    if(currentRef !== null) {
      var width = currentRef.offsetWidth;
      this.setState({
        width: width,
      });
    }
  }

  render() {
    var width = this.state.width;

    return (<div className="bar-chart"
      ref={this.containerRef}>
      <BarChart {...this.props}
        width={width}
        compact={!this.props.collapseWidth || width < this.props.collapseWidth} />
    </div>);
  }

}

class BarChart extends Component {

  render() {
    var values = this.props.values;
    var width = this.props.width;

    var total = values.reduce((total, v) => total + v.amount, 0);
    var barWidths = values.map((v) => v.amount / total * width);

    var barOffsets = [0];
    for (var i = 0; i < barWidths.length; i++) {
      width = barWidths[i];
      var offset = barOffsets[barOffsets.length - 1] + width;
      barOffsets.push(offset);
    }

    var bars = values.map((value, i) => {
      var barX = barOffsets[i];
      var barWidth = barWidths[i];

      var description;
      if (this.props.compact) {
        description = (<g
            transform={ `translate(0, ${ this.props.barHeight + 40 * (i+1) })` } >
            <rect y={-20} width={20} height={20} fill={color(i)} />
            <text y={-8} x={25} alignmentBaseline="middle" className="description">{ value.label }</text>
        </g>);
      } else {
        description = (<g
            opacity={ value.amount <= 0 ? 0 : 1 }
            transform={ `translate(${ barX + 5 }, ${ this.props.barHeight - 5 })` } >
            <text y={30} className="description">{ value.label }</text>
        </g>);
      }

      return (<g
        role="presentation"
        key={i}>
        <desc>{ value.label }: { value.amount }</desc>
        <rect
          className="bar"
          transform={ `translate(${barX}, 0) scale(${barWidth}, 1)` }
          width={ 1 }
          height={ this.props.barHeight }
          fill={ color(i) } />
        <g
          opacity={ value.amount <= 0 ? 0 : 1 }
          transform={ `translate(${ barX + 8 }, ${ this.props.barHeight - 8 })` }
          className="label" >
          <text className="amount">{ value.amount ? format.dollarsShort(value.amount) : '' }</text>
        </g>
        { description }
      </g>);
    });

    var descriptionHeight;
    if (this.props.compact) {
      descriptionHeight = 40 * values.length;
    } else {
      descriptionHeight = 30;
    }

    return (<svg
      role="img"
      width="100%"
      aria-labelledby="title desc"
      height={ this.props.barHeight + descriptionHeight }>
      <title id="title">{ this.props.title }</title>
      <desc id="desc">{ this.props.desc }</desc>
      {bars}
    </svg>);
  }

}

BarChart.defaultProps = {
  barHeight: 50,
};
